export default [{
  id: 'president01', 
  name: 'President',
  surname: 'Asshole, Capitalism or Scum',
  description: 'Race to get rid of all of your cards in order to become "president"',
  imageUrl: 'images/PresidentAI.png',
  minPlayers: 4,
  maxPlayers: 8,
  minTime: 5,
  maxTime: 15,
  category: 'Party',
  classAttBackground: 'bg-primary bg-gradient',
  classAttPlayers: 'bg-light text-dark',
  classAttTime: 'bg-light text-dark',
  classAttButton: 'btn-light',
  classAttImage: 'bg-light',
}, {
  id: 'durak02', 
  name: 'Durak',
  surname: '"Fool", Kur or Russian War',
  description: 'Attack your opponents and defend yourself from others so as not to become the "fool"',
  imageUrl: 'images/DurakAI.png',
  minPlayers: 2,
  maxPlayers: 6,
  minTime: 5,
  maxTime: 15,
  category: 'Strategy',
  classAttBackground: 'bg-danger bg-gradient',
  classAttPlayers: 'bg-warning',
  classAttTime: 'bg-warning',
  classAttButton: 'btn-warning text-white',
  classAttImage: 'bg-warning'
}, {
  id: 'mentiroso03', 
  name: 'Mentiroso',
  surname: '"Bullshit" or "Desconfío"',
  description: 'Lie, cheat and hunt the other liars to get rid of all your cards',
  imageUrl: 'images/MentirosoAI.png',
  minPlayers: 4,
  maxPlayers: 7,
  minTime: 10,
  maxTime: 20,
  category: 'Frenetic',
  classAttBackground: 'bg-dark bg-gradient',
  classAttPlayers: 'bg-rojo',
  classAttTime: 'bg-rojo',
  classAttButton: 'btn-danger text-white',
  classAttImage: 'bg-danger'
}, {
  id: 'chinchon04', 
  name: 'Chinchón',
  surname: '"Conga", "Chintón" or "Rummy"',
  description: 'Form a straight flush or three of a kind with 7 cards',
  imageUrl: 'images/ChinchonAI.png',
  minPlayers: 2,
  maxPlayers: 4,
  minTime: 10,
  maxTime: 30,
  category: 'Calm',
  classAttBackground: 'bg-info bg-gradient',
  classAttPlayers: 'bg-light text-primary',
  classAttTime: 'bg-light text-primary',
  classAttButton: 'btn-light text-primary',
  classAttImage: 'bg-light',
}, {
  id: 'higherlower05', 
  name: 'Higher Lower',
  surname: '"Hi-Lo" or Guess the Card',
  description: 'Predict if the next card drawn will have a higher or lower',
  imageUrl: 'images/HigherLowerAI.png',
  minPlayers: 2,
  maxPlayers: 10,
  minTime: 1,
  maxTime: 15,
  category: 'Frenetic',
  classAttBackground: 'bg-success bg-gradient',
  classAttPlayers: 'bg-rojo',
  classAttTime: 'bg-rojo',
  classAttButton: 'btn-danger text-white',
  classAttImage: 'bg-danger'
}];